import type { QuizLibrarySearchItem } from '@/api/gen/_model/quizLibrarySearchItem';

import { toFolderFromSearch } from '../../quiz-folder';
import type { LibraryItem } from '../types/library.types';

/**
 * 서버 판별자(`type`)를 도메인 판별자(`kind`)로 옮긴다.
 *
 * **코드베이스에서 `type` 을 읽는 유일한 지점이다.** 여기서 한 번 갈라 두면 목록·행·라우팅이
 * 전부 `kind` 만 보면 되고, `SearchQuizsetRes` 를 전제로 쓰인 기존 화면들은 손대지 않아도 된다.
 *
 * `type` 이 없는 응답은 퀴즈로 본다 — 자료실의 기존 유일 타입이라 가장 안전한 기본값이고,
 * 던지면 목록 한 줄 때문에 페이지 전체가 비어 버린다.
 */
export const toLibraryItem = (raw: QuizLibrarySearchItem): LibraryItem =>
  raw.type === 'QUIZSET_FOLDER'
    ? {
        kind: 'FOLDER',
        id: raw.id,
        folder: toFolderFromSearch(raw),
      }
    : { kind: 'QUIZ', id: raw.id, quiz: raw };
